import React from "react";
import { Taskbar } from "@/components/taskbar";
import { HeroSection } from "@/components/hero-section";
import { FaqSection } from "@/components/faq-section";
import { Footer } from "@/components/footer";
import { BeamsBackground } from "@/components/ui/beams-background";

const Index = () => {
  return (
    <div className="relative min-h-screen bg-purple-dark">
      <BeamsBackground />
      <Taskbar />
      <main className="flex-grow relative">
        <HeroSection />
        <div className="max-w-5xl mx-auto px-6 w-full">
          <FaqSection />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
